import { z } from 'zod';

import { EmployeeRole } from '@/common/graphql';

const EmployeePermissionEmployee = z.object({
  id: z.string(),
  preferredFullName: z.string().default(''),
  legalName: z.string().default(''),
  company: z.string(),
  businessUnit: z.string(),
  department: z.string(),
});

export const EmployeePermission = z.object({
  accessSpecificEmployees: z.boolean().default(false),
  companyIds: z.array(z.string()).default([]),
  employeeIds: z.array(z.string()).default([]),
  role: z.nativeEnum(EmployeeRole).nullable().default(null),
  idpFullAccess: z.boolean().default(false),
  companies: z
    .array(
      z.object({
        id: z.string(),
        name: z.string(),
      }),
    )
    .default([]),
  employees: z.array(EmployeePermissionEmployee).default([]),
});

export type EmployeePermissionType = z.infer<typeof EmployeePermission>;
export type EmployeePermissionEmployeeType = z.infer<typeof EmployeePermissionEmployee>;

export const isIdpFullAccessApplicableForRole = (role: EmployeeRole | null): boolean =>
  role === EmployeeRole.AdminPrivate;

// Shared between EmployeeRoleRadioGroup.tsx (Add) and EmployeeRoleDetails.tsx (Edit) so the two
// copies of this checkbox's label can't drift out of sync.
export const IDP_FULL_ACCESS_LABEL =
  'Full IDP visibility (all IDPs in scope, not only employees this person line-manages)';
